import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import GridContent from "./content-grid/content";
import GenreChildPageSkeleton from "../common/Skeleton/GenreChildPageSkeleton";

init({
  debug: true,
  visualDebug: true,
  rtl: true,
});

const GlobalStyle = createGlobalStyle`
  ::-webkit-scrollbar {
    display: none;
  }
`;

const AppContainer = styled.div`
  background: #121212;
  width: 100vw;
  height: 100vh;
  display: table;
  table-layout: fixed;
  direction: rtl;
`;

const SidebarCell = styled.div`
  display: table-cell;
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  vertical-align: top;
  height: 100vh;
`;

const ContentCell = styled.div`
  display: table-cell;
  width: calc(100vw - 250px);
  vertical-align: top;
  height: 100vh;
  overflow: visible;
`;

export default function SpitialProfileWatchHistory({ data, loading = false }) {
  return (
    <AppContainer>
      <GlobalStyle />
      <SidebarCell>
        <Menu focusKey="MENU" />
      </SidebarCell>
      <ContentCell>
        {loading ? (
          <GenreChildPageSkeleton isParent={false} rows={3} cols={5} />
        ) : (
          <GridContent data={data} title={"تاریخچه تماشا"} />
        )}
      </ContentCell>
    </AppContainer>
  );
}
